// Lib
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Utils
import { sendAmplitudeEvent } from '../../../../analytics/amplitudeService';

// Selectors
import getGridSize from '../../../../utils/grid/gridSizeSelector';
import { currentBoardEditorsAvatarInfoSelector } from './headerShareUtilSelector';
import { getCurrentBoardId } from '../../../../reducers/currentBoardId/currentBoardIdSelector';
import { currentBoardIsPublishedSelector } from '../../../../utils/permissions/elementPermissionsSelector';

// Actions
import { modalOpened } from '../../../../components/modal/modalActions';

// Hooks
import useFetchBoardSharingData from './useFetchBoardSharingData';

// Components
import HeaderShareAvatars from './HeaderShareAvatars';
import CurrentBoardHeaderUtil from '../CurrentBoardHeaderUtil';
import Button from '../../../../components/buttons/Button';
import Icon from '../../../../components/icons/Icon';

// Constants
import { ModalIds } from '../../../../components/modal/modalConstants';

// Styles
import './HeaderShareButtonUtil.scss';

const HeaderShareButtonUtil = () => {
    const gridSize = useSelector(getGridSize);
    const currentBoardId = useSelector(getCurrentBoardId);
    const currentBoardIsPublished = useSelector(currentBoardIsPublishedSelector);
    const currentBoardEditorsAvatarInfo = useSelector(currentBoardEditorsAvatarInfoSelector);

    const dispatch = useDispatch();
    const dispatchOpenShareModal = useCallback(() => dispatch(modalOpened(ModalIds.SHARE)), []);

    useFetchBoardSharingData();

    const onShareClick = useCallback(() => {
        sendAmplitudeEvent({ eventType: 'Clicked on share util' });
        dispatchOpenShareModal();
    }, [dispatchOpenShareModal]);

    const hideShareIcon = currentBoardIsPublished || currentBoardEditorsAvatarInfo.length > 0;

    return (
        <CurrentBoardHeaderUtil className="HeaderShareButtonUtil" onClick={dispatchOpenShareModal}>
            <HeaderShareAvatars
                dispatchOpenShareModal={dispatchOpenShareModal}
                currentBoardId={currentBoardId}
                gridSize={gridSize}
                users={currentBoardEditorsAvatarInfo}
            />

            <Button className="HeaderShareButton" onClickFn={onShareClick}>
                <div className="button-content">
                    {!hideShareIcon && <Icon name="share" />}
                    <div className="title">Share</div>
                </div>
            </Button>
        </CurrentBoardHeaderUtil>
    );
};

export default HeaderShareButtonUtil;
